import { FC } from "react";
import { Skeleton } from "@capacit-com/lara-law-shared-ui";

export const MetadataTypesSkeleton: FC = () => {
  return (
    <div className="flex gap-2">
      <Skeleton className="h-9 flex-1" />
      <Skeleton className="h-9 flex-1" />
      <Skeleton className="h-9 w-38" />
      <Skeleton className="h-9 w-10" />
    </div>
  );
};
